import React from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { registerUser } from '../../services/registratinService';
import { useHistory } from 'react-router-dom';
import { useState } from 'react';
import { toast } from 'react-toastify';
import emailValidator from '../../utils/emailValidator';

const Registration = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  const handleTyping = (
    field: string,
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { value } = event.target;
    field === 'email' ? setEmail(value) : setPassword(value);
  };

  const handleClose = () => {
    setShowModal(false);
    history.push('/login');
  };

  const handleSubmit = async (event: { preventDefault: () => void }) => {
    event.preventDefault();
    if (!emailValidator(email)) {
      return toast.error('Por favor insira um email válido.');
    }
    if (password.length < 6) {
      return toast.error('Sua senha deve conter no mínimo 6 caracteres.');
    }
    try {
      await registerUser(email, password);
      setShowModal(true);
    } catch (error) {
      toast.error(error?.response?.data?.msg || 'Algo deu errado.');
    }
  };

  return (
    <div className='login'>
      <Modal
        show={showModal}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
      >
        <Modal.Header closeButton>
          <Modal.Title>Verifique seu e-mail</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Por segurança, enviamos um link de ativação para o seu e-mail com
          validade de 24h.
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={handleClose} variant='danger'>Estou ciente</Button>
        </Modal.Footer>
      </Modal>
      ;
      <Form onSubmit={handleSubmit} className='login-form'>
        <Form.Group className='mb-3' controlId='formBasicEmail'>
          <Form.Label>Email</Form.Label>
          <Form.Control
            onChange={(event) => handleTyping('email', event)}
            type='email'
            placeholder='Insira seu e-mail'
          />
        </Form.Group>

        <Form.Group className='mb-3' controlId='formBasicPassword'>
          <Form.Label>Senha</Form.Label>
          <Form.Control
            onChange={(event) => handleTyping('password', event)}
            type='password'
            placeholder='Insira sua senha'
          />
          <Form.Text className='text-muted'>
            Seus dados não serão compartilhados.
          </Form.Text>
        </Form.Group>
        <div id='login-buttons'>
          <Button variant='primary' type='submit'>
            Concluir cadastro
          </Button>
          <Button variant='secondary' onClick={() => history.push('/login')}>
            Voltar ao login
          </Button>
        </div>
      </Form>
    </div>
  );
};

export default Registration;
